import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import apiService from "services/api-service";
import toast from "react-hot-toast";

const ChangePassword = () => {
	const [inputs, setInputs] = useState({
		old_password: "",
		password: "",
		confirm_password: "",
	});

	const [errors, setErrors] = useState({
		oldPasswordError: false,
		passwordError: false,
		confirmationError: false,
		error: false,
		textError: "",
	});
	const [loading, setLoading] = useState(false);

	const changeHandler = (e) => {
		setInputs({
			...inputs,
			[e.target.name]: e.target.value,
		});
	};

	const submitHandler = async (e) => {
		e.preventDefault();
		setLoading(true);
		setErrors({
			oldPasswordError: false,
			passwordError: false,
			confirmationError: false,
			error: false,
			textError: "",
		});

		if (inputs.old_password.trim().length === 0) {
			setErrors((prev) => ({
				...prev,
				oldPasswordError: true,
				error: true,
				textError: "La vecchia password è obbligatoria.",
			}));
			return;
		}
		if (inputs.password.trim().length < 6) {
			setErrors((prev) => ({
				...prev,
				passwordError: true,
				error: true,
				textError:
					"La nuova password deve contenere almeno 6 caratteri.",
			}));
			return;
		}
		if (inputs.confirm_password.trim() !== inputs.password.trim()) {
			setErrors((prev) => ({
				...prev,
				confirmationError: true,
				error: true,
				textError: "La conferma password non corrisponde.",
			}));
			return;
		}

		const formData = {
			old_password: inputs.old_password,
			password: inputs.password,
			confirm_password: inputs.confirm_password,
		};

		try {
			toast.loading("Cambiando password...", {
				id: "change-password-id",
			});
			const data = await apiService.post(
				"/change-password/",
				{},
				formData
			);
			setInputs({
				old_password: "",
				password: "",
				confirm_password: "",
			});
			toast.success("Password cambiata con successo", {
				id: "change-password-id",
			});
		} catch (err) {
			let textError = "Errore generico.";
			let details = null;

			if (err && typeof err === "object") {
				if (err.errors) {
					if (err.errors.old_password)
						textError = err.errors.old_password[0];
					else if (err.errors.password)
						textError = err.errors.password[0];
					else if (err.errors.confirm_password)
						textError = err.errors.confirm_password[0];
					else if (typeof err.errors === "string")
						textError = err.errors;
					else textError = "Errore di validazione.";
					details = JSON.stringify(err.errors, null, 2);
				} else if (err.message) {
					textError = err.message;
				} else if (typeof err === "string") {
					textError = err;
				}
			} else if (typeof err === "string") {
				textError = err;
			}

			setErrors((prev) => ({
				...prev,
				error: true,
				textError,
			}));
			if (details) toast.error(details, { id: "change-password-id" });
		} finally {
			setLoading(false);
		}
	};

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<Card style={{ marginTop: "5rem" }}>
				<MDBox
					variant="gradient"
					bgColor="info"
					borderRadius="lg"
					coloredShadow="success"
					mx={2}
					mt={-3}
					p={3}
					mb={1}
					textAlign="center"
				>
					<MDTypography
						variant="h4"
						fontWeight="medium"
						color="white"
						mt={1}
					>
						Cambia password
					</MDTypography>
					<MDTypography
						display="block"
						variant="button"
						color="white"
						my={1}
					>
						Inserisci la vecchia password e la nuova password per
						aggiornare
					</MDTypography>
				</MDBox>
				<MDBox pt={4} pb={3} px={3}>
					<MDBox
						component="form"
						role="form"
						method="POST"
						onSubmit={submitHandler}
					>
						<MDBox mb={2}>
							<MDInput
								type="password"
								label="Vecchia password"
								variant="standard"
								fullWidth
								name="old_password"
								value={inputs.old_password}
								onChange={changeHandler}
								error={errors.oldPasswordError}
							/>
						</MDBox>
						<MDBox mb={2}>
							<MDInput
								type="password"
								label="Nuova password"
								variant="standard"
								fullWidth
								name="password"
								value={inputs.password}
								onChange={changeHandler}
								error={errors.passwordError}
							/>
						</MDBox>
						<MDBox mb={2}>
							<MDInput
								type="password"
								label="Conferma nuova password"
								variant="standard"
								fullWidth
								name="confirm_password"
								value={inputs.confirm_password}
								onChange={changeHandler}
								error={errors.confirmationError}
							/>
						</MDBox>
						{errors.error && (
							<MDAlert color="error" sx={{ mb: 2 }}>
								<MDTypography
									variant="caption"
									color="white"
									fontWeight="light"
								>
									{errors.textError}
								</MDTypography>
							</MDAlert>
						)}
						<MDBox mt={4} mb={1}>
							<MDButton
								variant="gradient"
								color="info"
								fullWidth
								type="submit"
								disabled={loading}
							>
								Cambia password
							</MDButton>
						</MDBox>
					</MDBox>
				</MDBox>
			</Card>
		</DashboardLayout>
	);
};

export default ChangePassword;
